export const themeConfig = {
  themeColor: "slate",
  direction: "ltr",
  mode: "light",
  locale: "en",
  primaryColorLevel: 600,
  cardBordered: false,
  panelExpand: false,
  controlSize: "md",
  navMode: "light",
  layout: {
    type: "modern",
    sideNavCollapse: false,
  },
};

// Global theme color - change this hex code to update entire platform theme
// Leave empty/null to use preset colors, or set a hex code for custom color
export const CUSTOM_PRIMARY_COLOR = ""; // e.g., "#ff5500" or "" for default
